/* Dubai Parts: keyboard accessibility for modal dialogs (Esc closes, Tab stays inside, focus returns to the opener). */
(function () {
  window.dpModalA11y = function (modal, closeFn) {
    var last = null;
    function focusables() {
      return [].slice.call(modal.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'))
        .filter(function (e) { return e.offsetParent !== null; });
    }
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); closeFn(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], end = f[f.length - 1], inside = modal.contains(document.activeElement);
      if (e.shiftKey && (!inside || document.activeElement === first)) { e.preventDefault(); end.focus(); }
      else if (!e.shiftKey && (!inside || document.activeElement === end)) { e.preventDefault(); first.focus(); }
    });
    return {
      opened: function (focusEl) {
        last = document.activeElement;
        setTimeout(function () { (focusEl || focusables()[0] || modal).focus(); }, 30);
      },
      closed: function () {
        if (last && last.focus) { try { last.focus(); } catch (err) {} }
        last = null;
      }
    };
  };
})();
